import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Hidden, Typography, Tooltip } from "@material-ui/core";
import { getIn } from "formik";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
    column: {
        display: "inline-block",
        marginRight: 20
    },
    label: {},
    value: {},
    cancelButton: {
        position: "absolute",
        bottom: "10px",
        right: "10px"
    }
}), {
    name: "DployExpandedRow"
});
export const ExpandedRow = (props) => {
    const { columnData, rowData, loadedData, ...rest } = props;
    const classes = useStyles(props);
    return (_jsx("table", { children: _jsx("tbody", { children: columnData
                .filter(col => col.hiddenInExpandable !== true)
                .map((col, key) => {
                const cellData = col.id
                    ? getIn(rowData, col.id)
                    : col.loadedId
                        ? getIn(loadedData, col.loadedId)
                        : undefined;
                const value = col.format
                    ? col.format(cellData, rowData, loadedData)
                    : cellData;
                const tooltip = col.tooltip
                    ? col.tooltip(cellData, rowData, loadedData)
                    : null;
                var content = (_jsx(Typography, { className: classes.value, children: value }));
                const Component = col.expandedComponent || col.component;
                if (typeof col.hiddenInExpandable === "function" &&
                    col.hiddenInExpandable(cellData, rowData, loadedData))
                    return null;
                if (Component)
                    content = (_jsx(Component, { rowData: rowData, loadedData: loadedData, ...rest, ...col.props, children: value }));
                return (_createElement(Hidden, { ...(typeof col.hiddenInExpandable === "object"
                        ? col.hiddenInExpandable
                        : null), key: key },
                    _jsxs("tr", { children: [col.label ? (_jsx("td", { className: classes.column, children: _jsx(Typography, { className: classes.label, children: col.label }) })) : null, _jsx("td", { colSpan: col.label ? 1 : 2, children: tooltip ? (_jsx(Tooltip, { title: tooltip, placement: "top-start", children: content })) : (content) })] })));
            }) }) }));
};
//# sourceMappingURL=ExpandedRow.js.map